<template>
	<div class="wp100 oh">
		<!-- 头部 -->
		<div class="disf jc-s ai-c pl10 mb5" style="height: 32px;">
			<p><i class="fs16 sz szminyizhengji mr5" style="color: #909399"></i>征文管理</p>
			<div>
				<!-- 	<el-button style="background-color: #f93e61; color: #ffffff" size="small" icon="el-icon-circle-plus"
					class="fs14" @click="openEditDrawer(undefined)">征文投稿
				</el-button> -->
			</div>
		</div>

		<!-- 投稿列表 -->
		<div class="wp100 bg-c-fff pb20 pl10 pr20" style="
		  height: calc(100vh - 125px);
		  overflow-y: auto;
		  width: calc(100% + 13px);
		">
			<my-list ref="list" config="essay/myessay.js" @search="searchData">
				<template v-slot:article_title="scope">
					<p><span class="col-gray fs14 pr10">标题</span><span class="fs14">{{scope.row.article_title}}</span>
					</p>
					<p><span class="fs14 pr10 col-gray">副标题</span><span
							class="fs14">{{scope.row.article_subtitle}}</span></p>
				</template>

				<template v-slot:author="scope">
					<p>{{scope.row.ext_param2[0].author}}<span
							class="pl3">{{scope.row.ext_param2[0].author_unit_1}}</span><span
							class="pl3">{{scope.row.ext_param2[0].author_unit_2}}</span></p>
					<p v-if="scope.row.ext_param2.length > 1">{{scope.row.ext_param2[1].author}}<span
							class="pl3">{{scope.row.ext_param2[1].author_unit_1}}</span><span
							class="pl3">{{scope.row.ext_param2[1].author_unit_2}}</span></p>
				</template>

				<template v-slot:reward="scope">
					<p v-if="scope.row.reward == -1">未评奖</p>
					<p v-else-if="scope.row.reward == 0">其他</p>
					<p v-else-if="scope.row.reward == 1">一等奖</p>
					<p v-else-if="scope.row.reward == 2">二等奖</p>
					<p v-else>三等奖</p>
				</template>

				<template v-slot:status="scope">
					<p v-if="scope.row.status == 1">待一审</p>
					<p v-else-if="scope.row.status == 2">待二审</p>
					<p v-else-if="scope.row.status == 3">待确认</p>
					<p v-else-if="scope.row.status == 4">已获奖</p>
					<p v-else>未获奖</p>
				</template>

				<!-- <template v-slot:oper="scope">
					<p class="point" v-if="scope.row.status < 4" style="color:rgb(80, 144, 240);"
						@click="openEditDrawer(scope.row.id)">编辑</p>
				</template> -->
			</my-list>
		</div>

		<my-drawer title="编辑投稿" path="essay/edit.vue" ref="editDrawer" :show-close="false" :withHeader="false"
			direction="rtl" size="80%" @editCallback="editCallback" append-to-body></my-drawer>
	</div>
</template>

<script>
	import {
		getInfo
	} from "../../utils/token";
	import * as dataConfig from "../../data/config";
	export default {
		data() {
			return {};
		},

		methods: {
			//自定义列表数据源
			searchData(data, resolve) {
				let _page = data.page.split('__')[0];
				this.$api.essay
					.essayList(_page)
					.then(resolve)
					.catch((res) => {});
			},

			// 打开抽屉
			openEditDrawer(id) {
				this.$refs.editDrawer.show(id);
			},

			// 编辑弹层关闭方法
			editCallback() {
				this.$refs.list.search();
			}
		},
	};
</script>

<style>
</style>
